import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect, useState } from 'react';
import { buildFilteredHighlightedProducts } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { getMobileMerchCardsToShow } from '../../../constants/merchCards/MerchCardsToShow';
import { SUITE_CARD } from '../../../constants/tracking/TrackingSources';
import MobileMerchCardSelectorButtons from '../../mobile/MobileMerchCardSelectorButtons';
import MobileSuiteFeatureTable from '../../mobile/MobileSuiteFeatureTable';
import { FreeCard } from '../cards/FreeCard';
import { StandardSuiteCard } from '../cards/suite/StandardSuiteCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileSuiteCardContainer = ({
  screen
}) => {
  const productLevelsToShow = getMobileMerchCardsToShow('CRM_SUITE');
  const [selectedProductLevel, setSelectedProductLevel] = useState(productLevelsToShow[0]);
  useEffect(() => {
    if (!productLevelsToShow.includes(selectedProductLevel)) {
      setSelectedProductLevel(productLevelsToShow[0]);
    }
  }, [productLevelsToShow, selectedProductLevel]);
  const productsByProductLine = {
    MARKETING: buildFilteredHighlightedProducts({
      productLine: 'MARKETING',
      productLevels: [selectedProductLevel]
    }),
    SALES: buildFilteredHighlightedProducts({
      productLine: 'SALES',
      productLevels: [selectedProductLevel]
    }),
    SERVICE: buildFilteredHighlightedProducts({
      productLine: 'SERVICE',
      productLevels: [selectedProductLevel]
    }),
    OPERATIONS: buildFilteredHighlightedProducts({
      productLine: 'OPERATIONS',
      productLevels: [selectedProductLevel]
    }),
    CMS: buildFilteredHighlightedProducts({
      productLine: 'CMS',
      productLevels: [selectedProductLevel]
    })
  };
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      marginInline: "auto",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(MobileMerchCardSelectorButtons, {
        options: productLevelsToShow,
        selectedOption: selectedProductLevel,
        onClick: setSelectedProductLevel
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "500",
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(CardGrid, {
          columns: 1,
          rowGap: "0",
          children: selectedProductLevel === 'FREE' ? /*#__PURE__*/_jsx(FreeCard, {
            productLine: "crm",
            columnStart: 1,
            trackingSource: SUITE_CARD
          }) : /*#__PURE__*/_jsx(StandardSuiteCard, {
            productLevel: selectedProductLevel,
            screen: screen,
            columnStart: 1
          })
        })
      }), /*#__PURE__*/_jsx(MobileSuiteFeatureTable, {
        productsByProductLine: productsByProductLine,
        productLevel: selectedProductLevel,
        screen: screen
      })]
    })
  });
};